import { useEffect, useRef, useState } from "react";
import Modal from "./Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBath,
  faBed,
  faRuler,
  faLocationDot,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import { useNavigate } from "react-router-dom";
import "../Home/styles/Detail.css";
import MortgageCalculator from "./MortgageCalculator";

export default function DetailPageNew({ data }) {
  const navigate = useNavigate();
  const zoomRef = useRef(null);
  let [index, setIndex] = useState(-1);
  let [modal, setModal] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    projectName: "",
    type: "",
    desc: "",
    message: "",
    state: "",
    location: "",
    latitude: "",
    longitude: "",
    bedrooms: "",
    floors: "",
    bathrooms: "",
    occupancy: "",
    configuration: "",
    convenience: "",
    layout: "",
    parking: "",
    view: "",
    square: "",
    price: "",
    display: "",
    status: "",
    listedBy: "",
    email: "",
    number: "",
    images: [], // handle with File input
    features: [],
    keyFeatures: [],
    exclusiveAmenities: [],
    primeLocation: [],
    propertyType: "",
    propertyStatus: "",
    addedOn: "", // date input (format: yyyy-mm-dd)
    handOverDate: "", // date input
    elevators: "",
    totalArea: "",
    buildingName: "",
    pools: "",
    mapUrl: "",
    reference: "",
    zone: "",
    permit_no: "",
    down_payment: "",
    dev_img: "",
    payment_plan: "",
    completion: "",
  });

  let [images, setImages] = useState([]);

  useEffect(() => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        ...data,
      }));

      // Fix: Map string URLs to { src, alt }
      if (Array.isArray(data.images)) {
        setImages(
          data.images.map(
            (img, i) =>
              typeof img === "string"
                ? { src: img, alt: data.location || `Property Image ${i + 1}` }
                : img // If already an object, keep as is
          )
        );
      } else {
        setImages([]);
      }
    }
    console.log(data);
  }, [data]);
  const tel = `tel: ${formData.number} `;
  const email = `mailto: ${formData.email} `;
  const whatsap = `https://api.whatsapp.com/send?phone=${formData.number}
&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Varela%202  `;
  console.log(images, "images");
  const [message, setMessage] = useState("");
  const showMessage = (text) => {
    setMessage(text);
    setTimeout(() => setMessage(""), 3000); // Hide after 3 seconds
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check this out!",
          text: "This is something cool!",
          url: window.location.href,
        });
        showMessage("Shared successfully!");
      } catch (error) {
        console.error("Share failed:", error);
        showMessage("Sharing cancelled.");
      }
    } else {
      // Fallback: copy link
      try {
        await navigator.clipboard.writeText(window.location.href);
        showMessage("Link copied to clipboard!");
      } catch (error) {
        console.error("Copy failed:", error);
        showMessage("Failed to copy link.");
      }
    }
  };
  return (
    <div className="bg-white mx-[2vw] md:mx-[10vw] md:mt-[12vh] *:font-sans">
      <div className="px-8 pt-6 mt-12">
        {/* Image Gallery Section */}
        <div className="property-gallery">
          <div className="mx-auto mt-6 grid grid-cols-1 md:grid-cols-4 md:grid-rows-2 gap-2 h-auto md:h-[70vh]">
            {images.map((image, i) => {
              return i <= 4 ? (
                <div
                  className={`${
                    i === 0 ? "row-span-2 col-span-2" : "col-span-1"
                  } relative overflow-hidden rounded-[4px] cursor-pointer`}
                  onClick={() => setIndex(i)}
                  key={i}
                >
                  <img
                    className="object-cover object-center w-full h-full transition-all duration-75 ease-in hover:scale-105"
                    src={`${image.src}`}
                    alt={`${image.alt}`}
                  />
                  {images.length > 5 && i === 4 && (
                    <div className="absolute top-0 left-0 h-full w-full bg-[#0005] flex items-center justify-center">
                      <p className="text-lg font-semibold text-center text-white cursor-pointer">
                        Show More
                      </p>
                    </div>
                  )}
                </div>
              ) : (
                ""
              );
            })}

            <Lightbox
              plugins={[Counter, Zoom]}
              close={() => setIndex(-1)}
              open={index >= 0}
              slides={images}
              index={index}
              zoom={{ ref: zoomRef }}
            />
          </div>
        </div>
        {/* Property Details */}

        <div className="grid grid-cols-1 gap-4 md:grid-cols-12">
          <div className="md:col-span-8">
            <div className="flex mt-0 text-left section-title">
              <a href={formData.mapUrl} target="_blank">
                <button className="action-btn enq-bttns flex rounded my-1 mr-2 text-sm border border-[#173D73] text-[#173D73] hover:bg-[#173D73] hover:text-white duration-200 sm:my-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  Map
                </button>
              </a>
              <a href="/contact" target="_blank">
                {" "}
                <button className="request-action-btn enq-bttns flex rounded my-1 mr-2 text-sm border border-[#173D73] text-[#173D73] hover:bg-[#173D73] hover:text-white duration-200 sm:my-2">
                  Request video
                </button>
              </a>
            </div>
            {message && (
              <div
                style={{
                  marginTop: "8px",
                  padding: "6px 12px",
                  backgroundColor: "#e0ffe0",
                  color: "#006400",
                  borderRadius: "4px",
                  display: "inline-block",
                  fontSize: "14px",
                }}
              >
                {message}
              </div>
            )}
            {/* Property Header */}
            <div className="property-header">
              <div className="price">{formData.price}</div>
              <div className="action-buttons">
                <button className="save-btn ">
                  <i className="far fa-heart" /> Save
                </button>
                <button className="share-btn" onClick={handleShare}>
                  <i className="fas fa-share-alt" /> Share
                </button>
              </div>
            </div>
            {/* Property Title */}
            <div className="text-left property-title">{formData.name}</div>
            <div className="text-left">{formData.location}</div>
            {/* Property Features */}
            <div className="property-features">
              <div className="feature">
                <i className="fas fa-bed" /> {formData.bedrooms} Bed
              </div>
              <div className="feature">
                <i className="fas fa-bath" /> {formData.bathrooms} Baths
              </div>
              <div className="feature">
                <i className="fas fa-vector-square" /> {formData.square} sqft
              </div>
            </div>
            {/* Highlight Box */}
            <div className="highlight-box">
              <div className="text-lg text-left highlight-text">
                HIGH ROI | COMPLETION {formData.completion}
              </div>
            </div>
            {/* Developer Info */}
            <div className="text-lg developer-info">
              Direct from the Developer | No commission fees | Cash Offer
            </div>
            {/* Property Description */}
            {formData.desc}
            {/* Key Features (Collapsible) */}
            {/* Key Features (Collapsible) */}
            {(data?.keyFeatures?.length || 0) > 0 && (
              <>
                <div className="text-lg text-left section-title">
                  Key Features:
                </div>
                <div
                  id="key-features-section"
                  style={{
                    transition: "max-height 0.4s ease",
                    overflow: "hidden",
                  }}
                >
                  <ul className="pl-5 space-y-2 text-sm text-left">
                    {(formData.keyFeatures || []).map((f, i) => (
                      <li key={i}>
                        {" "}
                        <span className="inline-block w-2 h-2 rotate-45 bg-black "></span>{" "}
                        {f}
                      </li>
                    ))}
                  </ul>

                  {/* <p className="text-sm">
                    Offering a collection of sophisticated studios, 1, and
                    2-bedroom apartments. Immerse yourself in a world where
                    luxury meets comfort, with meticulously crafted interiors
                    and stunning panoramic views of Dubai Hills and the city
                    skyline.
                  </p>*/}
                </div>
              </>
            )}
            {/* Amenities */}
            {(formData?.exclusiveAmenities?.length || 0) > 0 && (
              <>
                <div className="text-left section-title">Amenities:</div>
                <ul className="pl-5 space-y-2 text-sm text-left">
                  {formData.exclusiveAmenities.map((f, i) => (
                    <li key={i}>
                      {" "}
                      <span className="inline-block w-2 h-2 rotate-45 bg-black "></span>{" "}
                      {f}
                    </li>
                  ))}
                </ul>
              </>
            )}
            {/*Prime Location*/}
            {(formData?.primeLocation?.length || 0) > 0 && (
              <>
                <div className="text-left section-title">Prime Location:</div>
                <ul className="pl-5 space-y-2 text-sm text-left">
                  {formData.primeLocation.map((f, i) => (
                    <li key={i}>
                      {" "}
                      <span className="inline-block w-2 h-2 rotate-45 bg-black "></span>{" "}
                      {f}
                    </li>
                  ))}
                </ul>
              </>
            )}
            <p className="text-sm text-left">
              Secure your luxury apartment today – Direct from the Developer |
              No Commission | Flexible Payment Plan!
            </p>
            <p className="text-left">
              Call/Whatsapp{" "}
              <a href="tel:+971528284121" className="read-more">
                +971 528284121
              </a>{" "}
              or email at propertyhub@ucs-mail.com
              <a
                href={"mailto: propertyhub@ucs-mail.com "}
                className="read-more"
              >
                Send e-mail
              </a>
            </p>
            {/* <div className="text-left read-more" id="read-less-toggle">
              Read Less <i className="fas fa-chevron-up" />
            </div> */}
            {/* Property Information Section */}
            <div className="mt-4 text-left property-info">
              <div className="info-title">Property Information</div>
              <div className="row">
                <div className="col-md-6">
                  <table className="text-sm info-table">
                    <tbody>
                      {formData?.type?.trim() && (
                        <tr>
                          <td>Type</td>
                          <td>{formData.type}</td>
                        </tr>
                      )}
                      {formData?.zone?.trim() && (
                        <tr>
                          <td>Zone</td>
                          <td> {formData.zone}</td>
                        </tr>
                      )}
                      {formData?.reference?.trim() && (
                        <tr>
                          <td>Reference no.</td>
                          <td>{formData.reference}</td>
                        </tr>
                      )}
                      {formData?.completion?.trim() && (
                        <tr>
                          <td>Completion</td>
                          <td>{formData.completion}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="col-md-6">
                  <table className="text-sm info-table">
                    <tbody>
                      {formData?.down_payment?.trim() && (
                        <tr>
                          <td>Down Payment</td>
                          <td>{formData.down_payment} %</td>
                        </tr>
                      )}
                      {formData?.addedOn?.trim() && (
                        <tr>
                          <td>Added on</td>
                          <td>{formData.addedOn}</td>
                        </tr>
                      )}

                      {formData?.handOverDate?.trim() && (
                        <tr>
                          <td>Handover date</td>
                          <td>{formData.handOverDate}</td>
                        </tr>
                      )}
                      {formData?.payment_plan?.trim() && (
                        <tr>
                          <td>Payment Plan</td>
                          <td>{formData.payment_plan}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* Building Information Section */}
            <div className="mt-4 text-left property-info">
              <div className="info-title">
                Building Information{" "}
                <i className="fas fa-check-circle text-success" />
              </div>
              <div className="row">
                <div className="col-md-6">
                  <table className="text-sm info-table">
                    <tbody>
                      {formData?.buildingName?.trim() && (
                        <tr>
                          <td>Building Name</td>
                          <td>{formData.buildingName}</td>
                        </tr>
                      )}

                      {formData.floors?.trim() && (
                        <tr>
                          <td>Total Floors</td>
                          <td>{formData.floors}</td>
                        </tr>
                      )}

                      {formData.propertyType?.trim() && (
                        <tr>
                          <td>Property Type</td>
                          <td>{formData.propertyType}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="col-md-6">
                  <table className="text-sm info-table">
                    <tbody>
                      {formData.parking?.trim() && (
                        <tr>
                          <td>Total Parking Spaces</td>
                          <td>{formData.parking}</td>
                        </tr>
                      )}

                      {formData.totalArea?.trim() && (
                        <tr>
                          <td>Total Building Area</td>
                          <td>{formData.totalArea}</td>
                        </tr>
                      )}

                      {formData.elevators?.trim() && (
                        <tr>
                          <td>Elevators</td>
                          <td>{formData.elevators}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* Features / Amenities Section */}
            {/*  {(formData?.exclusiveAmenities?.length || 0) > 0 && (
              <div className="mt-4 text-left property-amenities">
                <div className="section-title">Features / Amenities</div>
                <div className="amenities-grid">
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Pool") && (
                        <div key={i} className="amenity-item">
                          <i className="fa-solid fa-swimming-pool fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Sauna") && (
                        <div key={i} className="amenity-item">
                          <i className="fa-solid fa-hot-tub-person fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Spa") && (
                        <div key={i} className="amenity-item">
                          <i className="fa-solid fa-spa fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Gym") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-dumbbell fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Fitness") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-dumbbell fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Gardens".toLowerCase()) && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-tree fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Golf".toLowerCase()) && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-golf-ball-tee fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Room".toLowerCase()) && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-gamepad fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Grill".toLowerCase()) && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-leaf   fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}

                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Park") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-tree   fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Beach") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-umbrella-beach fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Wellness") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-wind fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Outdoor") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-chair fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Jungle") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-paw fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Promenade") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-street-view fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Podium") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-trophy fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("cinema") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-film fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Kids") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-gamepad fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("Play") && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-gamepad fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {formData.exclusiveAmenities.map(
                    (f, i) =>
                      f.includes("amphitheater".toLowerCase()) && (
                        <div key={i} className="amenity-item">
                          <i class="fa-solid fa-theater-masks fa-2x" />
                          <div className="amenity-name">{f}</div>
                        </div>
                      )
                  )}
                  {/*<div className="amenity-item">
                    <i className="fa-solid fa-swimming-pool fa-2x" />
                    <div className="amenity-name">Swimming Pool</div>
                  </div>
                  <div className="amenity-item">
                    <i className="fa-solid fa-hot-tub-person fa-2x" />
                    <div className="amenity-name">Sauna</div>
                  </div>
                  <div className="amenity-item">
                    <i className="fa-solid fa-spa fa-2x" />
                    <div className="amenity-name">Steam Room</div>
                  </div>
                  <div className="amenity-item">
                    <i className="fa-solid fa-mountain-sun fa-2x" />
                    <div className="amenity-name">View</div>
                  </div>
                 
                </div>
              </div>
            )}
            */}
            {/* Project Information Section */}
            <div className="mt-4 text-left property-info">
              <div className="info-title">
                Project Information{" "}
                <i className="fas fa-check-circle text-success" />
              </div>
              <div className="row">
                <div className="col-md-6">
                  <table className="text-sm info-table">
                    <tbody>
                      {formData.projectName?.trim() && (
                        <tr>
                          <td>Project Name</td>
                          <td>{formData.projectName}</td>
                        </tr>
                      )}

                      {formData.status?.trim() && (
                        <tr>
                          <td>Project Status</td>
                          <td className="text-success">{formData.status}</td>
                        </tr>
                      )}

                      {/* Last Inspected is a static value, so keep as is 
                      {formData.status?.trim() && (
                        <tr>
                          <td>Last Inspected</td>
                          <td className="text-success">{formData.status}</td>
                        </tr>
                      )}*/}
                    </tbody>
                  </table>
                </div>
                <div className="col-md-6">
                  <table className="info-table">
                    <tbody>
                      {formData.listedBy?.trim() && (
                        <tr>
                          <td>Developer</td>
                          <td>{formData.listedBy}</td>
                        </tr>
                      )}
                      {formData.handOverDate?.trim() && (
                        <tr>
                          <td>Handover</td>
                          <td>{formData.completion}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* Similar Property Transactions Section 
            <div className="mt-4 text-left property-info">
              <div className="info-title">
                Similar Property Transactions{" "}
                <i className="fas fa-check-circle text-success" />
              </div>
              <div className="mb-2">
                1 Bedroom Apartments in Binghatti Hillviews
              </div>
              <div className="mb-3">
                <button className="btn btn-outline-secondary btn-sm active">
                  Dubai Science Park
                </button>
                <button className="btn btn-outline-success btn-sm">
                  Binghatti Hillviews
                </button>
              </div>
              <ul className="mb-2 nav nav-tabs">
                <li className="nav-item">
                  <a className="nav-link active" href="#">
                    SALE
                  </a>
                </li>
              </ul>
              <div className="table-responsive">
                <table className="table mb-0 align-middle table-bordered">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Area (sqft)</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>10 Feb 2025</td>
                      <td>853</td>
                      <td>AED 1,155,000</td>
                    </tr>
                    <tr>
                      <td>5 Feb 2025</td>
                      <td>853</td>
                      <td>AED 1,153,000</td>
                    </tr>
                    <tr>
                      <td>31 Jan 2025</td>
                      <td>806</td>
                      <td>AED 1,317,499</td>
                    </tr>
                    <tr>
                      <td>8 Jan 2025</td>
                      <td>853</td>
                      <td>AED 1,200,000</td>
                    </tr>
                    <tr>
                      <td>29 Dec 2024</td>
                      <td>815</td>
                      <td>AED 1,240,000</td>
                    </tr>
                    <tr>
                      <td>27 Dec 2024</td>
                      <td>853</td>
                      <td>AED 1,200,000</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-2">
                <a href="#" className="text-success">
                  View sale transactions for Apartments In Binghatti Hillviews{" "}
                  <i className="fas fa-arrow-right" />
                </a>
              </div>
            </div>*/}
          </div>
          <div className=" top-[80px] md:col-span-4 self-start ">
            {/* Developer Card */}
            <div className="developer-card ">
              <div className="developer-logo">
                <img src={`${formData.dev_img}`} />
              </div>
              <div className="developer-name">{formData.listedBy}</div>
              <div className="contact-buttons">
                <a href={email}>
                  <div className="whatsapp-btn enq-bttns flex rounded my-1 mr-2 text-sm border border-[#173D73] text-[#173D73] hover:bg-[#173D73] hover:text-white duration-200 sm:my-2">
                    <i
                      className="far fa-envelope"
                      style={{ marginRight: "8px" }}
                    />{" "}
                    Email
                  </div>
                </a>

                <div className="whatsapp-btn enq-bttns  flex rounded my-1 mr-2 text-sm border border-[#173D73] text-[#173D73] hover:bg-[#173D73] hover:text-white duration-200 sm:my-2">
                  <a href={tel}>
                    {" "}
                    <i
                      className="fas fa-phone"
                      style={{ marginRight: "8px" }}
                    />{" "}
                    Call{" "}
                  </a>
                </div>

                <a href={whatsap} target="_blank">
                  <div className="whatsapp-btn enq-bttns  flex rounded my-1 mr-2 text-sm border border-[#173D73] text-[#173D73] hover:bg-[#173D73] hover:text-white duration-200 sm:my-2">
                    <i
                      className="fab fa-whatsapp"
                      style={{ marginRight: "8px" }}
                    />
                    Whatsapp
                  </div>
                </a>
              </div>
            </div>
            {/*
            <div className="mb-4 developer-bio">
              <div className="contact-buttons">
                <div className="">Binghatti Developers</div>
                <div className="">
                  <a>View all properties</a>
                </div>
              </div>
            </div>
            */}
            <MortgageCalculator />

            {/* Dubai Science Park Card */}
            {/*<div className="sidebar-card">
              <div
                className="card-image"
                style={{
                  backgroundImage: 'url("https://via.placeholder.com/400x120")',
                }}
              ></div>
              <div className="card-content">
                <div className="card-title">Dubai Science Park</div>
                <div className="card-text">
                  See the community attractions and Read...
                </div>
              </div>
            </div>*/}
            {/* Luxury Villas Card */}
            {/* <div className="sidebar-card">
              <div className="card-content">
                <div className="card-title">
                  Luxury Villas from AED 1.96M in Dubai
                </div>
                <div className="card-text">
                  Enjoy world-class community living | Flexible payment plan
                  options available
                </div>
              </div>
            </div>*/}
            {/* DAMAC Card */}
            {/* <div className="sidebar-card">
              <div
                className="card-image"
                style={{
                  backgroundImage: 'url("https://via.placeholder.com/400x120")',
                }}
              ></div>
              <div className="card-content d-flex justify-content-between align-items-center">
                <img src="https://via.placeholder.com/100x30" alt="DAMAC" />
                <button className="btn btn-success">Enquire Now</button>
              </div>
            </div>*/}
            {/* Useful Links Section */}
            {/*<div className="links-section">
              <div className="links-title">Useful Links</div>
              <ul className="links-list">
                <li>
                  <a href="#">Properties for sale in Dubai</a>
                </li>
                <li>
                  <a href="#">Properties for sale in Dubai Science Park</a>
                </li>
                <li>
                  <a href="#">Properties for sale in Binghatti Hillviews</a>
                </li>
                <li>
                  <a href="#">1 Bedroom Apartments for sale in Dubai</a>
                </li>
                <li>
                  <a href="#">
                    1 Bedroom Apartments for sale in Dubai Science Park
                  </a>
                </li>
                <li>
                  <a href="#">
                    1 Bedroom Apartments for sale in Binghatti Hillviews
                  </a>
                </li>
              </ul>
            </div>*/}
            {/* Nearby Section */}
            {/* <div className="nearby-section">
              <div className="nearby-title">Near Binghatti Hillviews</div>
              <ul className="nearby-list">
                <li>
                  <a href="#">Skyville Residences Apartments</a>
                </li>
                <li>
                  <a href="#">Empire Living Apartments</a>
                </li>
                <li>
                  <a href="#">SAAS Hills Apartments</a>
                </li>
                <li>
                  <a href="#">11 Hills Park Apartments</a>
                </li>
                <li>
                  <a href="#">Orchid Residence Apartments</a>
                </li>
              </ul>
           </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
}

